import { createSlice } from '@reduxjs/toolkit';
import {
  byIdReducerFn,
  createPaginationSlice,
  defaultInitialState,
} from './common.reducer';

/**
 * @public
 * @name edgeFileExportSlice
 * @description Declares a slice for redux store state.
 */
export const efeSlice = createSlice({
  name: 'edgeFileExports',
  initialState: defaultInitialState,
  reducers: {
    clearEdgeFileExports: () => ({ ...defaultInitialState }),
    addEdgeFileExports: (state, action) => ({
      ...state,
      byId: {
        ...state.byId,
        ...action.payload.reduce(byIdReducerFn('edgeFileExportID'), {}),
      },
    }),
  },
});

/**
 * @private
 */
const efeUiInitialState = {
  machineID: '',
  searchTerm: '',
  downloadingFile: false,
};
/**
 * @public
 * @name edgeFileExportUiSlice
 * @description Declares a slice for redux store state.
 */
export const efeUiSlice = createSlice({
  name: 'edgeFileExports',
  initialState: efeUiInitialState,
  reducers: {
    searchMachineByName: (state, action) => ({
      ...state,
      searchTerm: action.payload,
    }),
    selectMachineByID: (state, action) => ({
      ...state,
      machineID: action.payload,
    }),
    downloadingFile: (state, action) => ({
      ...state,
      downloadingFile: action.payload,
    }),
    clearEfeUiState: () => ({ ...efeUiInitialState }),
  },
});

/**
 * @private
 * @name edgeFileExportPaginationSlice
 * @description Declares a pagination slice for redux store state to cache component ui state.
 */
export const efePaginationSlice = createPaginationSlice(efeSlice.name);

/**
 * @public
 * @name edgeFileExportActions
 * @description Provides actions for edge file exports.
 */
export const efeActions = efeSlice.actions;

/**
 * @public
 * @name edgeFileExportUiActions
 * @description Provides actions for edge file export.
 */
export const efeUiActions = efeUiSlice.actions;

/**
 * @name edgeFileExportPagingActions
 * @description Provides paging actions for edge file exports.
 */
export const efePagingActions = efePaginationSlice.actions;
